import * as React from "react";
import { useNavigate } from "react-router";

import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import List from "@mui/material/List";

import { logFetchError, pairedFetchApi } from "../../util/fetchApi";
import CloseableDialogTitle from "../common/CloseableDialogTitle";
import { useCurrentUser } from "../hooks/currentUser";
import { useStatus } from "../hooks/status";

import AboutListItemV2 from "./DeviceDialog/AboutListItem";
import GestureControlListItem from "./DeviceDialog/GestureControlListItem";
import WifiListItem from "./DeviceDialog/WifiListItem";
import useDialog from "./useDialog";

export default function AdvancedSettingsDialog(): React.JSX.Element {
    const navigate = useNavigate();
    const { setDialogType } = useDialog();
    const { features, isAdmin } = useCurrentUser();
    const { status } = useStatus();
    const [gestureAvailable, setGestureAvailable] =
        React.useState<boolean>(false);

    React.useEffect(() => {
        async function fetchData() {
            if (status?.clientId) {
                const show = await pairedFetchApi<string[]>(
                    status.clientId,
                    "/api/features",
                );
                setGestureAvailable(show.includes("gestures"));
            }
        }

        fetchData().catch((e) => {
            logFetchError(e);
        });
    }, [status?.clientId]);

    const handleClose = React.useCallback(() => {
        setDialogType("Device");
    }, [setDialogType]);

    return (
        <>
            <CloseableDialogTitle onClose={handleClose}>
                Advanced Settings
            </CloseableDialogTitle>
            <DialogContent dividers>
                <List
                    sx={{
                        my: 0.5,
                        "& .MuiListItem-root": {
                            borderStyle: "solid",
                            borderWidth: 1,
                            borderColor: (t) => t.palette.grey[400],
                            borderBottomStyle: "none",
                            "&:last-child": {
                                borderBottomStyle: "solid",
                            },
                        },
                    }}
                >
                    <AboutListItemV2 hideIfNoUpdate={false} />
                    {features.includes("WIFI-RESET") && <WifiListItem />}
                    {features.includes("GESTURE_CONTROL") &&
                        gestureAvailable && <GestureControlListItem />}
                </List>
                {isAdmin() && (
                    <Button
                        fullWidth
                        onClick={() => {
                            setDialogType(null);
                            navigate("/content/status");
                        }}
                        sx={{ mt: 2 }}
                    >
                        Trainer Status
                    </Button>
                )}
            </DialogContent>
        </>
    );
}
